export const ANALYTICS_EVENT_TYPE = 'dash.analyticsEvent';
export const FEEDBACK_EVENT_ORIGIN = 'coursewareFrontend';

export const COURSE_TYPE_SECTION_MANAGER = 'section_manager';
export const COURSE_TYPE_SECTION = 'section';

export const PRODUCT_MODELS = Object.freeze({
  readandpractice: 1,
  skills: 2,
  quantitative: 3,
  qualitative: 4,
  essentials: 5,
  goreact: 6,
  'ccw-pages': 7,
});

export const QQ_SUPPORTED_PRODUCT_MODELS = [
  PRODUCT_MODELS.quantitative,
  PRODUCT_MODELS.qualitative,
  PRODUCT_MODELS.goreact,
  PRODUCT_MODELS.essentials,
];

export const REVISION_COLORS = {
  MOST_USED: '#004B71',
  STRONGLY_USED: '#006DB8',
  AVERAGE_USED: '#3192D3',
  LESS_USED: '#B0DAFF',
  LEAST_USED: '#E0F1FF',
};

export const VIEW_RELATION_TYPES = Object.freeze({
  RESOURCES_VIEW_ID: 1,
  COURSE_PLANNER_VIEW_ID: 2,
  READING_VIEW_ID: 3,
  CUSTOM_CONTENT_VIEW_ID: 4,
});
